import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { loginWithGoogleCredentialsEventEmitter } from 'components/Login';
import jsonp from 'jsonp';
import { toggleLoginBox } from 'components/Login/redux';
import makeRequest from 'utils/makeRequest';
import _get from 'lodash.get';
import Cookie from '../../../utils/cookies';
import { isPrimeUser } from '../../../utils/common';
import s from './GoogleEAFlow.scss';

// Google extended acces flow component applicable for google newshowcase only for free reads
function GoogleEAFlow({ toggleloginBox, userData, storymsid, isWapView }) {
  console.log('css', s);
  const [isLoggedin, setLoggedin] = useState(false);
  const [msid] = useState(storymsid);
  let domainUrl;
  let channelJsso;
  if (isWapView) {
    domainUrl = 'https://m.timesofindia.com';
    channelJsso = 'WAP';
  } else {
    domainUrl = 'https://timesofindia.indiatimes.com';
    channelJsso = 'web';
  }
  function getAllowedMsids() {
    return new Promise(resolve => {
      const url =
        'https://subs.timesofindia.com/subscriptions/proxy/gsc/fetch-showcase/json';
      //const url = 'https://stgsubs.timesofindia.com/subscriptions/proxy/gsc/fetch-showcase/json';

      if (!sessionStorage.getItem('GE_Access_msids')) {
        makeRequest
          .get(url, {}, 'skipfeedengine')
          .then(resp => {
            if (resp && resp.data && resp.data.data) {
              const allowedMsids =
                resp.data.data.length > 0
                  ? resp.data.data.map(obj => parseInt(obj.msid, 10))
                  : [];
              sessionStorage.setItem(
                'GE_Access_msids',
                JSON.stringify({
                  data: allowedMsids,
                  stored_at: new Date(),
                }),
              );
              resolve(allowedMsids);
            } else {
              resolve([]);
            }
          })
          .catch(err => {
            resolve([]);
            // eslint-disable-next-line no-console
            console.log('Fetch Error :msids', err);
          });
      } else {
        const msidsData = JSON.parse(sessionStorage.getItem('GE_Access_msids'));
        const now = new Date();
        const expiration = new Date(msidsData.stored_at);
        expiration.setMinutes(expiration.getMinutes() + 10);

        if (now.getTime() > expiration.getTime()) {
          sessionStorage.removeItem('GE_Access_msids');
          getAllowedMsids()
            .then(allowedMsids => {
              resolve(allowedMsids);
            })
            .catch(err => {
              resolve([]);
              // eslint-disable-next-line no-console
              console.log('Fetch Error :msids', err);
            });
        } else {
          resolve(msidsData.data);
        }
      }
    });
  }
  function checkShowcaseUrl() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    return (
      Object.keys(params).length !== 0 && params.utm_source === 'newsshowcase'
    );
  }
  function getUrlParams() {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const params = Object.fromEntries(urlSearchParams.entries());
    if (Object.keys(params).length !== 0 && params.constructor === Object) {
      return params;
    }
    return null;
  }
  function initializeEASwg(alreadyConfigured) {
    // eslint-disable-next-line no-console
    console.log('.userData.isLoggedIn', userData);
    // eslint-disable-next-line no-console
    console.log('msid', msid);

    function isGaa() {
      // Validate GAA params.
      const params = getUrlParams();
      if (
        !params ||
        !params.gaa_at ||
        !params.gaa_n ||
        !params.gaa_sig ||
        !params.gaa_ts ||
        parseInt(params.gaa_ts, 16) < Date.now() / 1000
      ) {
        return false;
      }
      return true;
    }

    const isArticleFree = () => false;

    (window.SWG = window.SWG || []).push(subscriptions => {
      if (!alreadyConfigured) {
        subscriptions.init('timesofindia.com:showcase');
      }
      window.subscriptions = subscriptions;
      function getUserState(ssoid, rgTimeSso) {
        const ssoid1 = ssoid || Cookie.get('ssoid') || Cookie.get('ssoId');
        const timestamp =
          rgTimeSso || Cookie.get('rgtime')
            ? parseInt(Cookie.get('rgtime'), 10)
            : parseInt(new Date().getTime() / 1000, 10);
        //const timestamp = parseInt(new Date().getTime() / 1000, 10);

        const key = `toi_userstate_${ssoid1}`;
        const userStateDetails =
          localStorage &&
          localStorage.getItem(key) !== '' &&
          JSON.parse(localStorage.getItem(key));
        let userState = '';
        if (
          userStateDetails &&
          userStateDetails?.userState &&
          userStateDetails?.stored_at + 30 * 24 * 60 * 60 > timestamp
        ) {
          userState = userStateDetails.userState;
        }
        if (!userState) {
          userState =
            (ssoid1 && {
              metering: {
                state: {
                  id: ssoid1,
                  // Standard attributes which affect your meters.
                  standardAttributes: {
                    registered_user: {
                      timestamp: timestamp - 10,
                    },
                  },
                },
              },
            }) ||
            '';
          if (userState) {
            localStorage.setItem(
              key,
              JSON.stringify({
                userState,
                stored_at: timestamp,
              }),
            );
          }
        }
        return userState;
      }

      //entitlements with publisher promise
      function checkPublisherSubscriberEntitlements() {
        return new Promise(resolve => {
          let publisherEntitlement = {};
          const paidstoriesArr =
            sessionStorage.getItem('paidstories') &&
            sessionStorage.getItem('paidstories') != null
              ? sessionStorage.getItem('paidstories').split(',')
              : [];
          if (isPrimeUser()) {
            publisherEntitlement = { granted: 1, grantReason: 'SUBSCRIBER' };
          } else if (
            typeof msid !== 'undefined' &&
            typeof paidstoriesArr !== 'undefined' &&
            paidstoriesArr.length > 0
          ) {
            if (paidstoriesArr.includes(msid.toString())) {
              publisherEntitlement = { granted: 1, grantReason: 'SUBSCRIBER' };
            }
          }
          resolve(publisherEntitlement);
        });
      }
      function showLoginPopup(visible = true) {
        if (document.getElementById('login-popup')) {
          if (visible) {
            document
              .getElementById('login-popup')
              .style.removeProperty('visibility');
          } else {
            document.getElementById('login-popup').style.visibility = 'hidden';
          }
        }
      }
      // See Sync entitlements with Google section
      function checkShowcaseEntitlement(userState) {
        // const urlSearchParams = new URLSearchParams(window.location.search);
        // const params = Object.fromEntries(urlSearchParams.entries());
        // if(Object.keys(params).length !== 0 && params.gaa_at && [90156452, 90296654].includes(window.msid)){
        //     alert(window.location.href);
        // }
        //toggleloginBox(false);
        if (
          document.getElementById('user-sign-in') &&
          document
            .getElementById('user-sign-in')
            .getElementsByClassName('close-btn')[0]
        ) {
          document
            .getElementById('user-sign-in')
            .getElementsByClassName('close-btn')[0]
            .click();
        }
        setTimeout(() => {
          showLoginPopup(true);
        }, 1000);

        if (userState) {
          // Send userState to Google
          subscriptions.getEntitlements(userState);
        }
      }

      function syncEntitlementsWithGoogle() {
        checkShowcaseEntitlement(getUserState());
      }

      function showGoogleRegwall() {
        window.GaaMeteringRegwall.show({
          iframeUrl: `${domainUrl}/toi_reg_test.cms`,
        }).then(credentialResponse => {
          document.getElementsByTagName('body')[0].classList.remove('noScroll');
          //$('body').removeClass('ga-overflowy-hide');
          const channel = 'toi';
          if (credentialResponse && credentialResponse.credential) {
            window.alreadyLoggedinFlag = true;
            const jssoAPIGetURL =
              'https://jsso.indiatimes.com/sso/services/gponetaplogin/verify';
            const ru = 'bchjqhklhblchbhjglh1wbfbv';
            const onSuccessCallback = (err, resp) => {
              let ticketId;
              ticketId = resp?.data?.ticket;
              const ssoId = resp?.data?.ssoid;
              if (ssoId && ticketId) {
                const jssoCrosswalkObj = new window.JssoCrosswalk(
                  'toi',
                  channelJsso,
                );
                jssoCrosswalkObj.gpOneTapLogin(
                  credentialResponse.credential,
                  ssoResponse => {
                    ticketId = ssoResponse?.data?.ticket;
                    jssoCrosswalkObj.getValidLoggedInUser(response => {
                      if (response.code === 200) {
                        showLoginPopup(false);
                        loginWithGoogleCredentialsEventEmitter();
                        //To be removed: This patch is used to explicitly show the hidden signin form
                        //until process of dialog box complete or in case of failure

                        try {
                          jssoCrosswalkObj.getUserDetails(innerResponse => {
                            let rgTimeSso;
                            //setting rgTime & pass to userState if cookie is not set
                            if (
                              innerResponse &&
                              parseInt(innerResponse.code, 10) === 200 &&
                              typeof callback === 'function' &&
                              innerResponse.data &&
                              innerResponse.data.createdDate !== ''
                            ) {
                              rgTimeSso =
                                new Date(
                                  innerResponse.data.createdDate,
                                ).getTime() / 1000;
                            }
                            // eslint-disable-next-line no-console
                            console.log('innerResponse', innerResponse?.data);
                            const options = {};
                            options.ssoId =
                              ssoId ||
                              Cookie.get('ssoid') ||
                              Cookie.get('ssoId') ||
                              '';
                            options.ticketId =
                              ticketId ||
                              Cookie.get('TicketId') ||
                              Cookie.get('ticket') ||
                              '';
                            const { data } = response;
                            const socialappcdurl = `//${
                              window.location.hostname
                            }/v1validateTicket?ticketId=${
                              data.encTicket
                            }&channel=toi-wap&_=${new Date().getTime()}`;
                            jsonp(
                              socialappcdurl,
                              null,
                              (socialAppErr, socialData) => {
                                if (socialAppErr) {
                                  showLoginPopup(true);
                                }
                                // eslint-disable-next-line no-console
                                console.log('BBBB>>>>', socialData);
                                setTimeout(() => {
                                  checkShowcaseEntitlement(
                                    getUserState(
                                      ssoId ||
                                        Cookie.get('ssoid') ||
                                        Cookie.get('ssoId'),
                                      rgTimeSso,
                                    ),
                                  );
                                }, 1000);
                              },
                            );
                          });
                        } catch (innerErr) {
                          console.log('err', innerErr);
                          showLoginPopup(true);
                        }
                      }
                    });
                  },
                );
              }
            };
            jsonp(
              `${jssoAPIGetURL}?token=${
                credentialResponse.credential
              }&channel=${channel}&ru=${ru}`,
              null,
              onSuccessCallback,
            );
          }
        });
      }

      function isUserRegistered() {
        if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
          return true;
        }
        return false;
      }
      if (isGaa()) {
        if (checkShowcaseUrl()) {
          if (isArticleFree()) {
            subscriptions.setShowcaseEntitlement({
              entitlement: 'EVENT_SHOWCASE_UNLOCKED_FREE_PAGE',
              isUserRegistered: isUserRegistered(),
            });
          } else if (isUserRegistered()) {
            window.alreadyLoggedinFlag = true;
            if (document.getElementById('swg-regwall-container')) {
              window.GaaMeteringRegwall.remove();
            }
            document
              .getElementsByTagName('body')[0]
              .classList.remove('noScroll');
            //   $('body').removeClass('ga-overflowy-hide');
            syncEntitlementsWithGoogle();
          } else {
            window.alreadyLoggedinFlag = false;
            //$('body').addClass('ga-overflowy-hide');
            document.getElementsByTagName('body')[0].classList.add('noScroll');
            if (window.GaaMeteringRegwall) {
              showGoogleRegwall();
            }

            subscriptions.setOnLoginRequest(() => {
              // eslint-disable-next-line no-console
              console.log('setOnLoginRequest>>>>');

              //$(".signup_container").css('z-index', '2147483649');
              toggleloginBox(true);
              document
                .getElementById('login-popup')
                .classList.add('loginPopupGa');
              document.getElementById('swg-regwall-container').style.zIndex =
                'unset';
            });
          }
        }
      } else {
        const urlSearchParams = new URLSearchParams(window.location.search);
        const params = Object.fromEntries(urlSearchParams.entries());
        if (
          Object.keys(params).length !== 0 &&
          params.constructor === Object &&
          !params.entitlementcheck
        ) {
          window.location.search += '&entitlementcheck=noentitlements';
        }
      }
      subscriptions.setOnEntitlementsResponse(entitlementsPromise => {
        // Wait for Google check and publisher check to finish
        Promise.all([
          entitlementsPromise,
          checkPublisherSubscriberEntitlements(),
          getAllowedMsids(),
        ]).then(entitlements => {
          // Determine Google response from publisher response.
          //  debugger;
          const [
            googleEntitlement,
            publisherEntitlement,
            allowedMsids,
          ] = entitlements;
          if (allowedMsids.includes(parseInt(msid, 10))) {
            if (publisherEntitlement.granted) {
              // B.1b) User has access from publisher so unlock article
              // unlockArticle(); already unlocked
              // At the same time, share information about the entitlement with Google.
              // See here for the specification of PublisherEntitlement: https://git.io/Jk1SW
              if (publisherEntitlement.grantReason === 'SUBSCRIBER') {
                // B.1ai) The user has access because they have a subscription
                subscriptions.setShowcaseEntitlement({
                  entitlement: 'EVENT_SHOWCASE_UNLOCKED_BY_SUBSCRIPTION',
                  isUserRegistered: true,
                });
              }
            } else if (googleEntitlement.enablesThisWithGoogleMetering()) {
              // B.2a) Google returned metering entitlement so grant access
              googleEntitlement.consume(() => {
                // B.2ai) Consume the entitlement and trigger a dialog that lets the user
                // know Google provided them with a free read.
              });
            } else {
              subscriptions.setShowcaseEntitlement({
                entitlement: 'EVENT_SHOWCASE_NO_ENTITLEMENTS_PAYWALL',
                isUserRegistered: true,
              });
              const urlSearchParams = new URLSearchParams(
                window.location.search,
              );
              const params = Object.fromEntries(urlSearchParams.entries());
              if (
                Object.keys(params).length !== 0 &&
                params.constructor === Object &&
                !params.entitlementcheck
              ) {
                window.location.search += '&entitlementcheck=noentitlements';
              }
            }
          }
        });
      });

      subscriptions.setOnNativeSubscribeRequest(() => {
        window.location.href = `${domainUrl}/toi-plus/plans`;
      });
    });
  }

  function logoutActionForGA() {
    if (checkShowcaseUrl()) {
      const urlSearchParams = new URLSearchParams(window.location.search);
      const params = getUrlParams();
      if (
        Object.keys(params).length !== 0 &&
        params.constructor === Object &&
        params.entitlementcheck
      ) {
        urlSearchParams.delete('entitlementcheck');
        window.location.href = `${
          window.location.pathname
        }?${urlSearchParams.toString()}`;
      } else {
        initializeEASwg(true);
      }
    }
  }
  function loadGAScriptAndSwgInitialize() {
    const swgSrc = 'https://news.google.com/swg/js/v1/swg.js';
    const swgGaaSrc = 'https://news.google.com/swg/js/v1/swg-gaa.js';
    const swgScript = document.createElement('script');
    const swgGaaScript = document.createElement('script');

    swgScript.src = swgSrc;
    swgScript.async = true;

    swgGaaScript.src = swgGaaSrc;
    swgGaaScript.async = true;

    swgScript.setAttribute('subscriptions-control', 'manual');
    // eslint-disable-next-line func-names
    swgScript.onload = function() {
      document.body.appendChild(swgGaaScript);
    };
    // eslint-disable-next-line func-names
    swgGaaScript.onload = function() {
      initializeEASwg();
      window.gaaScriptLoaded = true;
    };
    document.body.appendChild(swgScript);
    window.gaInitFlag = true;
  }
  useEffect(
    () => {
      // eslint-disable-next-line no-console
      console.log('check useeffect!!', userData);
      if (!window.gaInitFlag) {
        loadGAScriptAndSwgInitialize(toggleloginBox, userData);
      } else if (
        isLoggedin &&
        !window.alreadyLoggedinFlag &&
        window.gaaScriptLoaded
      ) {
        initializeEASwg(true);
      } else if (!isLoggedin && window.alreadyLoggedinFlag) {
        //initializeEASwg(true);
        logoutActionForGA();
      }
    },
    [isLoggedin],
  );

  useEffect(
    () => {
      if (Object.keys(userData).length) {
        setLoggedin(userData?.isLoggedIn);
      }
    },
    [userData],
  );

  return <></>;
}
const mapStateToProps = state => ({
  userData: _get(state, 'login.userData'),
});

const mapDispatchToProps = dispatch => ({
  toggleloginBox: params => {
    dispatch(toggleLoginBox(params));
  },
});

GoogleEAFlow.propTypes = {
  storymsid: PropTypes.string,
  userData: PropTypes.arrayOf(PropTypes.shape({})),
  toggleloginBox: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  isWapView: PropTypes.bool.isRequired,
};

GoogleEAFlow.defaultProps = {
  storymsid: '',
  userData: {},
};
export default connect(mapStateToProps, mapDispatchToProps)(GoogleEAFlow);
